import { render, staticRenderFns } from "./application-view-title.vue?vue&type=template&id=4584e754"
import script from "./application-view-title.vue?vue&type=script&lang=js"
export * from "./application-view-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports